import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { DeliveryShipmentOpenQueueContainerModel } from '../../../../../../../models';

@Injectable({
    providedIn: 'root'
  })
  export class ShipmentOpenQueueService extends BaseApiTemplateService<DeliveryShipmentOpenQueueContainerModel> {
      // https://api-test.akaun.com/core2/tnt/dm/del/region-comp-branch-location-links

      //todo: del/ or no del/ ?
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del-shipment-processing-open-queues/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del-shipment-processing-open-queues/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del-shipment-processing-open-queues/backoffice-ep';
      this.httpClient = http;
    }
  }